import script from "./MessageTextField.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageTextField.vue?vue&type=script&lang=ts&setup=true"

import "./MessageTextField.vue?vue&type=style&index=0&id=eec55940&lang=css"

const __exports__ = script;

export default __exports__